import { useGLTF } from '@react-three/drei';

function ButtonStartModel() {
  const { nodes, materials } = useGLTF(
    '/models/buttonStart.gltf',
  );
  return (
    <group dispose={null} rotation={[0, -1.8, 0]} position={[2, -6, -0.4]}>
      <group position={[0.62, 1.27, -0.89]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
        <mesh geometry={nodes.Cubo002.geometry} material={materials.rose} />
        <mesh geometry={nodes.Cubo002_1.geometry} material={materials['rose dark']} />
      </group>
      <mesh geometry={nodes.Cubo009.geometry} material={materials['Material.001']} position={[1.14, 1.22, -4.18]} rotation={[Math.PI / 2, 0, -Math.PI / 2]} scale={[0.74, 1, 0.16]} />
    </group>
  );
}

useGLTF.preload('/models/buttonStart.gltf');

export default ButtonStartModel;
